import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PhoneValidator {

  /**
   * Checks if the input string 'phone' is a valid Phone Number (11 numbers)
   * @param phone
   * @returns true or false
   */
  public static isValidPhone(phone: String) {
    if (phone == null || phone.trim().length === 0) return false;

    //Extract only the numbers
    let phoneNumber = (phone.match(/\d+/g)||[]).join('');

    if (phoneNumber.length != 11) return false;
    return true;
  }

  /**
   * Extract only the numbers from input string 'phone'
   * @param phone
   * @returns string
   */
   public static getPhoneNumbers(phone: String) {
    if (phone == null || phone.length === 0) return "";

    return (phone.match(/\d+/g)||[]).join('');
  }

  /**
   * Formats the input string 'phone' to the pattern of phone [(00) 00000-0000]
   * @param phone
   * @returns String that contains the formatted phone
   */
  public static getFormattedPhone(phone: String) {
    let formatted = this.getPhoneNumbers(phone);

    if(formatted.length == 11) {
      formatted = formatted.replace(/(\d{2})(\d{5})(\d{4})/,'($1) $2-$3');
    }

    return formatted;
  }

}

